var TranslationService = /** @class */ (function () {
    function TranslationService(api) {
        var _this = this;
        this.fetchTranslations = function (app, key) {
            return _this.API.get("/translations".concat(app && "?app=".concat(app)).concat((key && "&key=".concat(key)) || ''));
        };
        this.createTranslation = function (translation) {
            return _this.API.post('/translations', translation);
        };
        this.updateTranslation = function (translation) { return _this.API.put('/translations', translation); };
        this.API = api;
    }
    TranslationService.prototype.getTranslation = function (translationId) {
        var url = "/translations/".concat(translationId);
        return this.API.get(url);
    };
    TranslationService.prototype.deleteTranslation = function (app, key) {
        return this.API.delete("/translations?app=".concat(app, "&key=").concat(key));
    };
    return TranslationService;
}());
export { TranslationService };
